module.exports = __webpack_public_path__ + "static/media/mail.11e316e7.svg";